const styles = {
	notFound: {
		textAlign: 'center',
		paddingTop: ['25px', '50px'],
		paddingBottom: ['25px', '50px'],
		img: {
			marginBottom: 30,
		},
		h3: {
			fontSize: 2,
			color: 'primary',
			marginBottom: [12, 15],
		},
	},
};

export default styles;
